/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateInvitationPairingMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type CreateInvitationPairingMutation = { createInvitationPairing: { __typename: 'InvitationPairing', id: string, code: string, secret: string, expiresAt: any } };

export type ClaimInvitationPairingMutationVariables = Types.Exact<{
  input: Types.ClaimInvitationPairingInput;
}>;


export type ClaimInvitationPairingMutation = { claimInvitationPairing: { __typename: 'ClaimInvitationPairingResult', status: Types.InvitationPairingClaimStatus, refToken?: string | null } };


export const CreateInvitationPairingDocument = gql`
    mutation CreateInvitationPairing {
  createInvitationPairing {
    id
    code
    secret
    expiresAt
  }
}
    `;
export type CreateInvitationPairingMutationFn = Apollo.MutationFunction<CreateInvitationPairingMutation, CreateInvitationPairingMutationVariables>;

/**
 * __useCreateInvitationPairingMutation__
 *
 * To run a mutation, you first call `useCreateInvitationPairingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInvitationPairingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInvitationPairingMutation, { data, loading, error }] = useCreateInvitationPairingMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateInvitationPairingMutation(baseOptions?: Apollo.MutationHookOptions<CreateInvitationPairingMutation, CreateInvitationPairingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInvitationPairingMutation, CreateInvitationPairingMutationVariables>(CreateInvitationPairingDocument, options);
      }
export type CreateInvitationPairingMutationHookResult = ReturnType<typeof useCreateInvitationPairingMutation>;
export type CreateInvitationPairingMutationResult = Apollo.MutationResult<CreateInvitationPairingMutation>;
export type CreateInvitationPairingMutationOptions = Apollo.BaseMutationOptions<CreateInvitationPairingMutation, CreateInvitationPairingMutationVariables>;
export const ClaimInvitationPairingDocument = gql`
    mutation ClaimInvitationPairing($input: ClaimInvitationPairingInput!) {
  claimInvitationPairing(input: $input) {
    status
    refToken
  }
}
    `;
export type ClaimInvitationPairingMutationFn = Apollo.MutationFunction<ClaimInvitationPairingMutation, ClaimInvitationPairingMutationVariables>;

/**
 * __useClaimInvitationPairingMutation__
 *
 * To run a mutation, you first call `useClaimInvitationPairingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClaimInvitationPairingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [claimInvitationPairingMutation, { data, loading, error }] = useClaimInvitationPairingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useClaimInvitationPairingMutation(baseOptions?: Apollo.MutationHookOptions<ClaimInvitationPairingMutation, ClaimInvitationPairingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClaimInvitationPairingMutation, ClaimInvitationPairingMutationVariables>(ClaimInvitationPairingDocument, options);
      }
export type ClaimInvitationPairingMutationHookResult = ReturnType<typeof useClaimInvitationPairingMutation>;
export type ClaimInvitationPairingMutationResult = Apollo.MutationResult<ClaimInvitationPairingMutation>;
export type ClaimInvitationPairingMutationOptions = Apollo.BaseMutationOptions<ClaimInvitationPairingMutation, ClaimInvitationPairingMutationVariables>;